module.exports = __webpack_public_path__ + "static/media/_title_8.f3e8c530.svg";